export const colors = {
	white: '#fff',
	darkBlue: '#252250',
	black2: '#121212',
	lightGrey: '#b3b3b3',
	yellow: '#fa6e42',
	yellowDark: '#d2461a',
	purple: '#ae3ec9',
	green: '#0ca678',
	greyBackground: 'rgba(255,255,255,0.1)',
	greyBackground__pressed: 'rgba(255,255,255,0.25)',
	spotifyGreen: '#1db954',
	darkGreyBackground: '#2A2A2A',
};
